import { render, staticRenderFns } from "./MyMealView.vue?vue&type=template&id=579b1154&scoped=true"
import script from "./MyMealView.vue?vue&type=script&lang=js"
export * from "./MyMealView.vue?vue&type=script&lang=js"
import style0 from "./MyMealView.vue?vue&type=style&index=0&id=579b1154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b1154",
  null
  
)

export default component.exports